module.exports = __webpack_public_path__ + "static/logo-a8a1a585c4ebc77899c17e5583db54fb.png";